import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const desk = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getDesksBySite (siteId) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/sites/${siteId}/desksWithDeskGroups`)
  },
  getAvailableDesks (locationId) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/desks/names`)
  },
  getDesksWithoutCamera(locationId, clientId){
    return Axios.get(`api/v1/client/${clientId}/location/${locationId}/desks-without-camera`)
  },
  getDesksWithCameraId(cameraId){
    return Axios.get(`api/v1/cameras/${cameraId}/desks`)
  },
  getDeskWithCamera(locationId, cameraId){
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/locations/${locationId}/cameras/${cameraId}/desks`)
  },
  getDesksPositions(locationId, clientId) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${clientId}/locations/${locationId}/desks-positions`)
  }
}

export default desk
